
import { Component, input } from '@angular/core';
import {
	ITableColumns,
	TableSkeletonComponent,
} from '@webapp/core/ui/components/table-skeleton/table-skeleton.component';

@Component({
	selector: 'app-policies-table-skeleton',
	imports: [TableSkeletonComponent],
	templateUrl: './policies-table-skeleton.component.html',
	styleUrl: './policies-table-skeleton.component.scss',
})
export class PoliciesTableSkeletonComponent {
	showUser = input<boolean>(true);
	showProducer = input<boolean>(true);

	get columns(): ITableColumns[] {
		return this.filterColumns([
			{ name: 'Asegurado', component: 'userBadge' },
			{ name: 'Cobertura', component: 'default' },
			{ name: 'Riesgo', component: 'iconTitle' },
			{ name: 'Productor', component: 'default' },
			{ name: 'Vigencia', component: 'default' },
			{ name: 'Estado', component: 'default' },
		]);
	}

	filterColumns(columns: ITableColumns[]) {
		return columns.filter(
			column =>
				(this.showProducer() || column.name !== 'Productor') &&
				(this.showUser() || column.name !== 'Asegurado')
		);
	}
}
